"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReviewedDocument = exports.RulesOrderType = exports.ReviewedDocumentProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _document = require("../utils/document");
var _webApi = require("../utils/web-api");
var _api = require("../utils/api");
var _rules = require("../utils/rules");
var _constants = require("../constants");
var _AuthContext = require("../context/AuthContext");
var _cacheManager = require("../utils/cacheManager");
var _AnalyticsContext = require("./AnalyticsContext");
var _toast = require("../utils/toast");
var _useDioptraFetch2 = require("../hooks/use-dioptra-fetch");
var _envManager = require("../utils/envManager");
var _safeFetch = require("../utils/safe-fetch");
var _authEvents = require("../utils/auth-events");
var _foldedTextSearch = require("@common/utils/foldedTextSearch");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["target_ooxml_before", "target_ooxml_after", "target_packages"],
  _excluded2 = ["target_texts"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t15 in e) "default" !== _t15 && {}.hasOwnProperty.call(e, _t15) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t15)) && (i.get || i.set) ? o(f, _t15, i) : f[_t15] = e[_t15]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RulesOrderType = exports.RulesOrderType = /*#__PURE__*/function (RulesOrderType) {
  RulesOrderType[RulesOrderType["Priority"] = 0] = "Priority";
  RulesOrderType[RulesOrderType["Order"] = 1] = "Order";
  return RulesOrderType;
}({});
var reviewedDocumentReducer = function reviewedDocumentReducer(state, action) {
  switch (action.type) {
    case "SET_LOADING":
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: action.payload
      });
    case "SET_CURRENT_REVIEW_ID":
      return _objectSpread(_objectSpread({}, state), {}, {
        currentReviewId: action.payload
      });
    case "SET_REVIEW_SUMMARIES":
      return _objectSpread(_objectSpread({}, state), {}, {
        reviewSummaries: action.payload
      });
    case "SET_REVIEW_DOCX_BLOB_URL":
      return _objectSpread(_objectSpread({}, state), {}, {
        reviewDocxBlobUrl: action.payload
      });
    case "SET_RULES_DATA":
      return _objectSpread(_objectSpread({}, state), {}, {
        reviewReport: action.payload
      });
    case "SET_SELECTED_RULE_UUID":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedRuleUuid: action.payload
      });
    case "SET_SEARCH_FILTER":
      return _objectSpread(_objectSpread({}, state), {}, {
        searchFilter: action.payload
      });
    case "SET_VALIDATION_MESSAGE":
      return _objectSpread(_objectSpread({}, state), {}, {
        validationMessage: action.payload
      });
    case "SET_PLAYBOOKS":
      return _objectSpread(_objectSpread({}, state), {}, {
        playbooks: action.payload
      });
    case "SET_IS_REPORT_DONE":
      return _objectSpread(_objectSpread({}, state), {}, {
        isReportDone: action.payload
      });
    case "SET_RULES_ORDER":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedRulesOrder: action.payload
      });
    case "SET_CONCEDED_RULES":
      return _objectSpread(_objectSpread({}, state), {}, {
        concededRules: action.payload
      });
    case "SET_RESPONDED_RULES":
      return _objectSpread(_objectSpread({}, state), {}, {
        respondedRules: action.payload
      });
    case "MARK_RULES_RESPONDED":
      {
        if (!state.reviewReport) {
          return state;
        }
        var respondedSet = new Set([].concat(_toConsumableArray(state.respondedRules), _toConsumableArray(action.payload)));
        var updatedReport = state.reviewReport.map(function (rule) {
          if (action.payload.includes(rule.rule.uuid)) {
            return _objectSpread(_objectSpread({}, rule), {}, {
              rule: _objectSpread(_objectSpread({}, rule.rule), {}, {
                rule_responded: true
              })
            });
          }
          return rule;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          respondedRules: Array.from(respondedSet),
          reviewReport: updatedReport
        });
      }
    case "UPDATE_ACTION_APPLIED":
      {
        if (!state.reviewReport) return state;
        var updatedRulesDataForAction = _toConsumableArray(state.reviewReport);
        var ruleIndexForAction = updatedRulesDataForAction.findIndex(function (r) {
          return r.rule.uuid === action.payload.ruleUuid;
        });
        if (ruleIndexForAction !== -1) {
          var rule = updatedRulesDataForAction[ruleIndexForAction];
          var updatedActionPlan = _toConsumableArray(rule.action_plan || []);
          if (updatedActionPlan[action.payload.actionIndex]) {
            var actionItem = updatedActionPlan[action.payload.actionIndex];
            var updatedSteps = _toConsumableArray(actionItem.steps || []);
            if (updatedSteps[action.payload.stepIndex]) {
              var step = updatedSteps[action.payload.stepIndex];
              updatedSteps[action.payload.stepIndex] = _objectSpread(_objectSpread({}, step), {}, {
                action_applied: action.payload.applied
              });
              updatedActionPlan[action.payload.actionIndex] = _objectSpread(_objectSpread({}, actionItem), {}, {
                steps: updatedSteps
              });
              updatedRulesDataForAction[ruleIndexForAction] = _objectSpread(_objectSpread({}, rule), {}, {
                action_plan: updatedActionPlan
              });
              if (state.currentReviewId) {
                var cacheKey = "action_applied_".concat(state.currentReviewId);
                var actionKey = "".concat(action.payload.ruleUuid, "_").concat(action.payload.actionIndex, "_").concat(action.payload.stepIndex);
                _cacheManager.cacheManager.getItem(cacheKey).then(function (cachedData) {
                  var newCachedData = _objectSpread(_objectSpread({}, cachedData || {}), {}, _defineProperty({}, actionKey, action.payload.applied));
                  return _cacheManager.cacheManager.setItem(cacheKey, newCachedData);
                }).catch(function (error) {
                  console.error("Failed to cache action_applied value:", error);
                });
              }
            }
          }
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          reviewReport: updatedRulesDataForAction
        });
      }
    case "UPDATE_ACTION_RECOVERY_WARNING":
      {
        if (!state.reviewReport) return state;
        var updatedRulesData = _toConsumableArray(state.reviewReport);
        var ruleIndex = updatedRulesData.findIndex(function (r) {
          return r.rule.uuid === action.payload.ruleUuid;
        });
        if (ruleIndex !== -1) {
          var _rule = updatedRulesData[ruleIndex];
          var _updatedActionPlan = _toConsumableArray(_rule.action_plan || []);
          if (_updatedActionPlan[action.payload.actionIndex]) {
            var _actionItem = _updatedActionPlan[action.payload.actionIndex];
            var _updatedSteps = _toConsumableArray(_actionItem.steps || []);
            if (_updatedSteps[action.payload.stepIndex]) {
              var _step = _updatedSteps[action.payload.stepIndex];
              _updatedSteps[action.payload.stepIndex] = _objectSpread(_objectSpread({}, _step), {}, {
                recovery_warning: action.payload.warning
              });
              _updatedActionPlan[action.payload.actionIndex] = _objectSpread(_objectSpread({}, _actionItem), {}, {
                steps: _updatedSteps
              });
              updatedRulesData[ruleIndex] = _objectSpread(_objectSpread({}, _rule), {}, {
                action_plan: _updatedActionPlan
              });

              // Persist alongside action_applied so the warning survives
              // page navigation, full unmount, and Word reload. Key shape
              // matches `action_applied_${reviewId}`: a single per-review
              // map from `${ruleUuid}_${actionIndex}_${stepIndex}` to the
              // warning string. A null warning deletes the entry rather
              // than storing an explicit null, keeping the cache compact.
              if (state.currentReviewId) {
                var _cacheKey = "recovery_warning_".concat(state.currentReviewId);
                var _actionKey = "".concat(action.payload.ruleUuid, "_").concat(action.payload.actionIndex, "_").concat(action.payload.stepIndex);
                _cacheManager.cacheManager.getItem(_cacheKey).then(function (cachedData) {
                  var nextData = _objectSpread({}, cachedData || {});
                  if (action.payload.warning === null) {
                    delete nextData[_actionKey];
                  } else {
                    nextData[_actionKey] = action.payload.warning;
                  }
                  return _cacheManager.cacheManager.setItem(_cacheKey, nextData);
                }).catch(function (error) {
                  console.error("Failed to cache recovery_warning value:", error);
                });
              }
            }
          }
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          reviewReport: updatedRulesData
        });
      }
    case "UPDATE_ACTION_OOXML":
      {
        if (!state.reviewReport) return state;
        var _action$payload = action.payload,
          ruleUuid = _action$payload.ruleUuid,
          actionIndex = _action$payload.actionIndex,
          stepIndex = _action$payload.stepIndex,
          ooxmlBefore = _action$payload.ooxmlBefore,
          ooxmlAfter = _action$payload.ooxmlAfter;
        return _objectSpread(_objectSpread({}, state), {}, {
          reviewReport: updateActionOoxmlInReport(state.reviewReport, ruleUuid, actionIndex, stepIndex, ooxmlBefore, ooxmlAfter)
        });
      }
    case "UPDATE_ACTION_TEXTS":
      {
        if (!state.reviewReport) return state;
        var _action$payload2 = action.payload,
          _ruleUuid = _action$payload2.ruleUuid,
          _actionIndex = _action$payload2.actionIndex,
          _stepIndex = _action$payload2.stepIndex,
          textRedline = _action$payload2.textRedline;
        return _objectSpread(_objectSpread({}, state), {}, {
          reviewReport: updateActionReportInReport(state.reviewReport, _ruleUuid, _actionIndex, _stepIndex, function (actionReport) {
            var target_ooxml_before = actionReport.target_ooxml_before,
              target_ooxml_after = actionReport.target_ooxml_after,
              target_packages = actionReport.target_packages,
              rest = _objectWithoutProperties(actionReport, _excluded);
            return _objectSpread(_objectSpread({}, rest), {}, {
              target_texts: textRedline
            });
          })
        });
      }
    case "SET_RULE_SECTION_ORDER":
      return _objectSpread(_objectSpread({}, state), {}, {
        ruleSectionOrder: action.payload.order,
        ruleSectionOrderKey: action.payload.key
      });
    case "SET_BOOKMARK_PARA_INDEX":
      return _objectSpread(_objectSpread({}, state), {}, {
        bookmarkToParaIndex: action.payload
      });
    default:
      return state;
  }
};
function updateActionOoxmlInReport(report, ruleUuid, actionIndex, stepIndex, ooxmlBefore, ooxmlAfter) {
  return updateActionReportInReport(report, ruleUuid, actionIndex, stepIndex, function (actionReport) {
    /**
     * WHY the step's texts go
     *   A step carries its redline in one shape or the other, never both. The text
     *   update drops the markup fields for the same reason, and the core drops them
     *   too when it records a regenerated text card. Leaving `target_texts` beside
     *   new markup left the step describing two different redlines, and which one
     *   reached the document depended on which field the consumer read first.
     */
    var target_texts = actionReport.target_texts,
      actionReportWithoutTexts = _objectWithoutProperties(actionReport, _excluded2);
    return _objectSpread(_objectSpread({}, actionReportWithoutTexts), {}, {
      target_ooxml_before: ooxmlBefore,
      target_ooxml_after: ooxmlAfter
    });
  });
}
function updateActionReportInReport(report, ruleUuid, actionIndex, stepIndex, nextActionReport) {
  var _step$action_report;
  var ruleIdx = report.findIndex(function (r) {
    return r.rule.uuid === ruleUuid;
  });
  if (ruleIdx === -1) return report;
  var rule = report[ruleIdx];
  var actionPlan = rule.action_plan || [];
  var actionItem = actionPlan[actionIndex];
  if (!actionItem) return report;
  var steps = actionItem.steps || [];
  var step = steps[stepIndex];
  if (!step) return report;
  var updatedSteps = _toConsumableArray(steps);
  updatedSteps[stepIndex] = _objectSpread(_objectSpread({}, step), {}, {
    action_report: nextActionReport((_step$action_report = step.action_report) !== null && _step$action_report !== void 0 ? _step$action_report : {})
  });
  var updatedActionPlan = _toConsumableArray(actionPlan);
  updatedActionPlan[actionIndex] = _objectSpread(_objectSpread({}, actionItem), {}, {
    steps: updatedSteps
  });
  var updatedReport = _toConsumableArray(report);
  updatedReport[ruleIdx] = _objectSpread(_objectSpread({}, rule), {}, {
    action_plan: updatedActionPlan
  });
  return updatedReport;
}
var initialState = {
  loading: true,
  reviewDocxBlobUrl: null,
  currentReviewId: null,
  applyActiveReview: function () {
    var _applyActiveReview = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            return _context.a(2, void 0);
        }
      }, _callee);
    }));
    function applyActiveReview() {
      return _applyActiveReview.apply(this, arguments);
    }
    return applyActiveReview;
  }(),
  reviewSummaries: [],
  reviewReport: null,
  selectedRuleUuid: null,
  setSelectedRuleUuid: function setSelectedRuleUuid() {
    return void 0;
  },
  searchFilter: null,
  validationMessage: null,
  playbooks: null,
  setPlaybooks: function setPlaybooks() {
    return void 0;
  },
  isReportDone: false,
  orderRules: function orderRules() {
    return void 0;
  },
  selectedRulesOrder: RulesOrderType.Priority,
  getRuleBookmarkNames: function getRuleBookmarkNames() {
    return [];
  },
  getRuleTrackedChanges: function getRuleTrackedChanges() {
    return [];
  },
  updateActionApplied: function updateActionApplied() {
    return void 0;
  },
  updateActionRecoveryWarning: function updateActionRecoveryWarning() {
    return void 0;
  },
  updateActionOoxml: function updateActionOoxml() {
    return void 0;
  },
  updateActionTexts: function updateActionTexts() {
    return void 0;
  },
  concededRules: [],
  respondedRules: [],
  updateConcededRules: function () {
    var _updateConcededRules = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            return _context2.a(2, void 0);
        }
      }, _callee2);
    }));
    function updateConcededRules() {
      return _updateConcededRules.apply(this, arguments);
    }
    return updateConcededRules;
  }(),
  updateRespondedRules: function () {
    var _updateRespondedRules = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            return _context3.a(2, void 0);
        }
      }, _callee3);
    }));
    function updateRespondedRules() {
      return _updateRespondedRules.apply(this, arguments);
    }
    return updateRespondedRules;
  }(),
  addConcededRule: function () {
    var _addConcededRule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            return _context4.a(2, void 0);
        }
      }, _callee4);
    }));
    function addConcededRule() {
      return _addConcededRule.apply(this, arguments);
    }
    return addConcededRule;
  }(),
  removeConcededRule: function () {
    var _removeConcededRule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            return _context5.a(2, void 0);
        }
      }, _callee5);
    }));
    function removeConcededRule() {
      return _removeConcededRule.apply(this, arguments);
    }
    return removeConcededRule;
  }(),
  addRespondedRule: function () {
    var _addRespondedRule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            return _context6.a(2, void 0);
        }
      }, _callee6);
    }));
    function addRespondedRule() {
      return _addRespondedRule.apply(this, arguments);
    }
    return addRespondedRule;
  }(),
  addRespondedRules: function () {
    var _addRespondedRules = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            return _context7.a(2, void 0);
        }
      }, _callee7);
    }));
    function addRespondedRules() {
      return _addRespondedRules.apply(this, arguments);
    }
    return addRespondedRules;
  }(),
  removeRespondedRule: function () {
    var _removeRespondedRule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            return _context8.a(2, void 0);
        }
      }, _callee8);
    }));
    function removeRespondedRule() {
      return _removeRespondedRule.apply(this, arguments);
    }
    return removeRespondedRule;
  }(),
  ruleSectionOrder: null,
  ruleSectionOrderKey: null,
  setRuleSectionOrder: function setRuleSectionOrder() {
    return void 0;
  },
  bookmarkToParaIndex: null
};
function buildBookmarkIndexMap(outline) {
  var map = new Map();
  if (!Array.isArray(outline)) return map;
  var _iterator = _createForOfIteratorHelper(outline),
    _step2;
  try {
    for (_iterator.s(); !(_step2 = _iterator.n()).done;) {
      var _section$dioptra_p_bo;
      var section = _step2.value;
      var _iterator2 = _createForOfIteratorHelper((_section$dioptra_p_bo = section === null || section === void 0 ? void 0 : section.dioptra_p_bookmarks) !== null && _section$dioptra_p_bo !== void 0 ? _section$dioptra_p_bo : []),
        _step3;
      try {
        for (_iterator2.s(); !(_step3 = _iterator2.n()).done;) {
          var entry = _step3.value;
          if (entry !== null && entry !== void 0 && entry.bookmark_name && typeof entry.paragraph_id === "number") {
            map.set(entry.bookmark_name, entry.paragraph_id);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return map;
}
function fetchReportPayload(_x) {
  return _fetchReportPayload.apply(this, arguments);
}
function _fetchReportPayload() {
  _fetchReportPayload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(data) {
    var reportPayload, bookmarkMap, _jsonResponse$report, reportResponse, jsonResponse, _t14;
    return _regenerator().w(function (_context22) {
      while (1) switch (_context22.p = _context22.n) {
        case 0:
          reportPayload = data.report;
          bookmarkMap = null;
          if (!data.reportFileUrl) {
            _context22.n = 5;
            break;
          }
          _context22.p = 1;
          _context22.n = 2;
          return (0, _safeFetch.safeFetch)(data.reportFileUrl);
        case 2:
          reportResponse = _context22.v;
          _context22.n = 3;
          return reportResponse.json();
        case 3:
          jsonResponse = _context22.v;
          reportPayload = (_jsonResponse$report = jsonResponse.report) !== null && _jsonResponse$report !== void 0 ? _jsonResponse$report : jsonResponse;
          bookmarkMap = buildBookmarkIndexMap(jsonResponse.outline);
          _context22.n = 5;
          break;
        case 4:
          _context22.p = 4;
          _t14 = _context22.v;
          if (!(_t14.status !== 404)) {
            _context22.n = 5;
            break;
          }
          throw _t14;
        case 5:
          return _context22.a(2, {
            reportPayload: reportPayload,
            bookmarkMap: bookmarkMap
          });
      }
    }, _callee22, null, [[1, 4]]);
  }));
  return _fetchReportPayload.apply(this, arguments);
}
var ReviewedDocumentContext = /*#__PURE__*/(0, _react.createContext)(initialState);
var ReviewedDocumentProvider = exports.ReviewedDocumentProvider = function ReviewedDocumentProvider(_ref) {
  var children = _ref.children;
  var _useReducer = (0, _react.useReducer)(reviewedDocumentReducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var pollingIntervalRef = (0, _react.useRef)(null);
  var currentPollingReviewIdRef = (0, _react.useRef)(null);
  var currentStateRef = (0, _react.useRef)(state);
  var respondedRulesSetRef = (0, _react.useRef)(new Set());
  var authHeaderRef = (0, _react.useRef)(authHeader);
  authHeaderRef.current = authHeader;
  var _useDioptraFetch = (0, _useDioptraFetch2.useDioptraFetch)(),
    dioptraFetch = _useDioptraFetch.dioptraFetch;
  var playbookCacheRef = (0, _react.useRef)(new Map());
  var playbookFetchPromisesRef = (0, _react.useRef)(new Map());

  // Keep refs updated so polling closures always use the latest values
  (0, _react.useEffect)(function () {
    currentStateRef.current = state;
    respondedRulesSetRef.current = new Set(state.respondedRules);
  }, [state]);
  var cachePlaybooks = (0, _react.useCallback)(function (playbooks) {
    playbooks.forEach(function (playbook) {
      if (playbook !== null && playbook !== void 0 && playbook.id) {
        playbookCacheRef.current.set(playbook.id, playbook);
      }
    });
  }, []);
  var resolvePlaybooks = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(playbookIds) {
      var ids, uniqueIds, resolvedMap, fetchPromises;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            ids = playbookIds.filter(Boolean);
            if (!(ids.length === 0)) {
              _context9.n = 1;
              break;
            }
            return _context9.a(2, []);
          case 1:
            uniqueIds = Array.from(new Set(ids));
            resolvedMap = new Map();
            fetchPromises = [];
            uniqueIds.forEach(function (id) {
              var cached = playbookCacheRef.current.get(id);
              if (cached) {
                resolvedMap.set(id, cached);
                return;
              }
              var pending = playbookFetchPromisesRef.current.get(id);
              if (!pending) {
                pending = dioptraFetch("".concat((0, _envManager.getEnv)("WEBAPP_API_BASE_URL"), "/api/playbooks/").concat(id)).then(function (playbook) {
                  if (playbook) {
                    playbookCacheRef.current.set(id, playbook);
                    return playbook;
                  }
                  return null;
                }).catch(function (error) {
                  throw error;
                }).finally(function () {
                  playbookFetchPromisesRef.current.delete(id);
                });
                playbookFetchPromisesRef.current.set(id, pending);
              }
              fetchPromises.push(pending.then(function (playbook) {
                if (playbook) {
                  resolvedMap.set(id, playbook);
                }
              }));
            });
            if (!(fetchPromises.length > 0)) {
              _context9.n = 2;
              break;
            }
            _context9.n = 2;
            return Promise.all(fetchPromises);
          case 2:
            return _context9.a(2, ids.map(function (id) {
              var _resolvedMap$get;
              return (_resolvedMap$get = resolvedMap.get(id)) !== null && _resolvedMap$get !== void 0 ? _resolvedMap$get : playbookCacheRef.current.get(id);
            }).filter(function (playbook) {
              return Boolean(playbook);
            }));
        }
      }, _callee9);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [dioptraFetch]);
  var getRuleBookmarkNames = function getRuleBookmarkNames(selectedRule) {
    var actionBookmarkNames = [];
    var actionPlan = selectedRule["action_plan"];
    if (actionPlan && actionPlan.length) {
      var _iterator3 = _createForOfIteratorHelper(actionPlan),
        _step4;
      try {
        for (_iterator3.s(); !(_step4 = _iterator3.n()).done;) {
          var _action$target_report;
          var action = _step4.value;
          if (action.steps && action.steps.length) {
            var _iterator4 = _createForOfIteratorHelper(action.steps),
              _step5;
            try {
              for (_iterator4.s(); !(_step5 = _iterator4.n()).done;) {
                var _step$action_report2, _step$action_report3;
                var step = _step5.value;
                if ((_step$action_report2 = step.action_report) !== null && _step$action_report2 !== void 0 && _step$action_report2.target_bookmarks) {
                  var _iterator5 = _createForOfIteratorHelper(step.action_report.target_bookmarks),
                    _step6;
                  try {
                    for (_iterator5.s(); !(_step6 = _iterator5.n()).done;) {
                      var bookmarkName = _step6.value;
                      if (bookmarkName && !actionBookmarkNames.includes(bookmarkName)) {
                        actionBookmarkNames.push(bookmarkName);
                      }
                    }
                  } catch (err) {
                    _iterator5.e(err);
                  } finally {
                    _iterator5.f();
                  }
                }
                if ((_step$action_report3 = step.action_report) !== null && _step$action_report3 !== void 0 && _step$action_report3.action_tracked_changes) {
                  var _iterator6 = _createForOfIteratorHelper(step.action_report.action_tracked_changes),
                    _step7;
                  try {
                    for (_iterator6.s(); !(_step7 = _iterator6.n()).done;) {
                      var change = _step7.value;
                      if (change.bookmark_name && !actionBookmarkNames.includes(change.bookmark_name)) {
                        actionBookmarkNames.push(change.bookmark_name);
                      }
                    }
                  } catch (err) {
                    _iterator6.e(err);
                  } finally {
                    _iterator6.f();
                  }
                }
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
          if ((_action$target_report = action.target_report) !== null && _action$target_report !== void 0 && _action$target_report.bookmark_name) {
            var bookmarks = Array.isArray(action.target_report.bookmark_name[0]) ? action.target_report.bookmark_name[0] : [action.target_report.bookmark_name[0]];
            var _iterator7 = _createForOfIteratorHelper(bookmarks),
              _step8;
            try {
              for (_iterator7.s(); !(_step8 = _iterator7.n()).done;) {
                var _bookmarkName = _step8.value;
                if (_bookmarkName && !actionBookmarkNames.includes(_bookmarkName)) {
                  actionBookmarkNames.push(_bookmarkName);
                }
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    return actionBookmarkNames;
  };
  var getRuleTrackedChanges = function getRuleTrackedChanges(selectedRule) {
    var actionTrackedChanges = [];
    var actionPlan = selectedRule["action_plan"];
    if (actionPlan && actionPlan.length) {
      var _iterator8 = _createForOfIteratorHelper(actionPlan),
        _step9;
      try {
        for (_iterator8.s(); !(_step9 = _iterator8.n()).done;) {
          var action = _step9.value;
          if (action.steps && action.steps.length) {
            var _iterator9 = _createForOfIteratorHelper(action.steps),
              _step0;
            try {
              for (_iterator9.s(); !(_step0 = _iterator9.n()).done;) {
                var _step$action_report4;
                var step = _step0.value;
                if ((_step$action_report4 = step.action_report) !== null && _step$action_report4 !== void 0 && _step$action_report4.action_tracked_changes) {
                  var _iterator0 = _createForOfIteratorHelper(step.action_report.action_tracked_changes),
                    _step1;
                  try {
                    for (_iterator0.s(); !(_step1 = _iterator0.n()).done;) {
                      var change = _step1.value;
                      if (change.tag === "del" || change.tag === "ins") {
                        actionTrackedChanges.push(change);
                      }
                    }
                  } catch (err) {
                    _iterator0.e(err);
                  } finally {
                    _iterator0.f();
                  }
                }
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
    return actionTrackedChanges;
  };
  var updateConcededRules = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(ruleIds) {
      var currentReviewId, currentSummaries, _t;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            currentReviewId = currentStateRef.current.currentReviewId;
            if (currentReviewId) {
              _context0.n = 1;
              break;
            }
            return _context0.a(2);
          case 1:
            if (authHeader) {
              _context0.n = 2;
              break;
            }
            return _context0.a(2);
          case 2:
            _context0.p = 2;
            _context0.n = 3;
            return (0, _webApi.updateReview)(authHeader, currentReviewId, {
              concededRules: ruleIds
            });
          case 3:
            dispatch({
              type: "SET_CONCEDED_RULES",
              payload: ruleIds
            });
            currentSummaries = currentStateRef.current.reviewSummaries;
            dispatch({
              type: "SET_REVIEW_SUMMARIES",
              payload: currentSummaries.map(function (summary) {
                return summary.id === currentReviewId ? _objectSpread(_objectSpread({}, summary), {}, {
                  review: summary.review ? _objectSpread(_objectSpread({}, summary.review), {}, {
                    concededRules: ruleIds
                  }) : summary.review
                }) : summary;
              })
            });
            _context0.n = 5;
            break;
          case 4:
            _context0.p = 4;
            _t = _context0.v;
            console.error("Failed to update conceded rules:", _t);
            sendError(_t, {
              component: "ReviewedDocumentContext",
              action: "update_conceded_rules",
              reviewId: currentReviewId,
              ruleIds: ruleIds
            });
            throw _t;
          case 5:
            return _context0.a(2);
        }
      }, _callee0, null, [[2, 4]]);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), [authHeader, sendError]);
  var updateRespondedRules = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(ruleIds) {
      var currentReviewId, currentSummaries, _t2;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            currentReviewId = currentStateRef.current.currentReviewId;
            if (currentReviewId) {
              _context1.n = 1;
              break;
            }
            return _context1.a(2);
          case 1:
            if (authHeader) {
              _context1.n = 2;
              break;
            }
            return _context1.a(2);
          case 2:
            _context1.p = 2;
            _context1.n = 3;
            return (0, _webApi.updateReview)(authHeader, currentReviewId, {
              respondedRules: ruleIds
            });
          case 3:
            dispatch({
              type: "SET_RESPONDED_RULES",
              payload: ruleIds
            });
            currentSummaries = currentStateRef.current.reviewSummaries;
            dispatch({
              type: "SET_REVIEW_SUMMARIES",
              payload: currentSummaries.map(function (summary) {
                return summary.id === currentReviewId ? _objectSpread(_objectSpread({}, summary), {}, {
                  review: summary.review ? _objectSpread(_objectSpread({}, summary.review), {}, {
                    respondedRules: ruleIds
                  }) : summary.review
                }) : summary;
              })
            });
            _context1.n = 5;
            break;
          case 4:
            _context1.p = 4;
            _t2 = _context1.v;
            console.error("Failed to update responded rules:", _t2);
            sendError(_t2, {
              component: "ReviewedDocumentContext",
              action: "update_responded_rules",
              reviewId: currentReviewId,
              ruleIds: ruleIds
            });
            throw _t2;
          case 5:
            return _context1.a(2);
        }
      }, _callee1, null, [[2, 4]]);
    }));
    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }(), [authHeader, sendError]);
  var addConcededRule = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(ruleId) {
      var newConcededRules, currentReviewReport, updatedRulesData, ruleIndex;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.n) {
          case 0:
            newConcededRules = _toConsumableArray(currentStateRef.current.concededRules);
            if (newConcededRules.includes(ruleId)) {
              _context10.n = 2;
              break;
            }
            newConcededRules.push(ruleId);
            _context10.n = 1;
            return updateConcededRules(newConcededRules);
          case 1:
            currentReviewReport = currentStateRef.current.reviewReport;
            if (currentReviewReport) {
              updatedRulesData = _toConsumableArray(currentReviewReport);
              ruleIndex = updatedRulesData.findIndex(function (r) {
                return r.rule.uuid === ruleId;
              });
              if (ruleIndex !== -1) {
                updatedRulesData[ruleIndex] = _objectSpread(_objectSpread({}, updatedRulesData[ruleIndex]), {}, {
                  rule: _objectSpread(_objectSpread({}, updatedRulesData[ruleIndex].rule), {}, {
                    rule_conceded: true
                  })
                });
                dispatch({
                  type: "SET_RULES_DATA",
                  payload: updatedRulesData
                });
              }
            }
          case 2:
            return _context10.a(2);
        }
      }, _callee10);
    }));
    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }(), [updateConcededRules]);
  var removeConcededRule = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(ruleId) {
      var newConcededRules, currentReviewReport, updatedRulesData, ruleIndex;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.n) {
          case 0:
            newConcededRules = currentStateRef.current.concededRules.filter(function (id) {
              return id !== ruleId;
            });
            _context11.n = 1;
            return updateConcededRules(newConcededRules);
          case 1:
            currentReviewReport = currentStateRef.current.reviewReport;
            if (currentReviewReport) {
              updatedRulesData = _toConsumableArray(currentReviewReport);
              ruleIndex = updatedRulesData.findIndex(function (r) {
                return r.rule.uuid === ruleId;
              });
              if (ruleIndex !== -1) {
                updatedRulesData[ruleIndex] = _objectSpread(_objectSpread({}, updatedRulesData[ruleIndex]), {}, {
                  rule: _objectSpread(_objectSpread({}, updatedRulesData[ruleIndex].rule), {}, {
                    rule_conceded: false
                  })
                });
                dispatch({
                  type: "SET_RULES_DATA",
                  payload: updatedRulesData
                });
              }
            }
          case 2:
            return _context11.a(2);
        }
      }, _callee11);
    }));
    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }(), [updateConcededRules]);
  var addRespondedRules = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(ruleIds) {
      var normalizedRuleIds, hasNewIds, mergedRespondedList, _t3;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.p = _context12.n) {
          case 0:
            normalizedRuleIds = Array.from(new Set(ruleIds.filter(Boolean)));
            if (!(normalizedRuleIds.length === 0)) {
              _context12.n = 1;
              break;
            }
            return _context12.a(2);
          case 1:
            hasNewIds = false;
            normalizedRuleIds.forEach(function (id) {
              if (!respondedRulesSetRef.current.has(id)) {
                respondedRulesSetRef.current.add(id);
                hasNewIds = true;
              }
            });
            if (hasNewIds) {
              _context12.n = 2;
              break;
            }
            return _context12.a(2);
          case 2:
            mergedRespondedList = Array.from(respondedRulesSetRef.current);
            dispatch({
              type: "MARK_RULES_RESPONDED",
              payload: normalizedRuleIds
            });
            _context12.p = 3;
            _context12.n = 4;
            return updateRespondedRules(mergedRespondedList);
          case 4:
            _context12.n = 6;
            break;
          case 5:
            _context12.p = 5;
            _t3 = _context12.v;
            console.error("Failed to merge responded rules:", _t3);
            throw _t3;
          case 6:
            return _context12.a(2);
        }
      }, _callee12, null, [[3, 5]]);
    }));
    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }(), [updateRespondedRules]);
  var addRespondedRule = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(ruleId) {
      return _regenerator().w(function (_context13) {
        while (1) switch (_context13.n) {
          case 0:
            _context13.n = 1;
            return addRespondedRules([ruleId]);
          case 1:
            return _context13.a(2);
        }
      }, _callee13);
    }));
    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }(), [addRespondedRules]);
  var removeRespondedRule = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(ruleId) {
      var newRespondedRules, currentReviewReport, updatedRulesData, ruleIndex;
      return _regenerator().w(function (_context14) {
        while (1) switch (_context14.n) {
          case 0:
            newRespondedRules = currentStateRef.current.respondedRules.filter(function (id) {
              return id !== ruleId;
            });
            respondedRulesSetRef.current = new Set(newRespondedRules);
            _context14.n = 1;
            return updateRespondedRules(newRespondedRules);
          case 1:
            currentReviewReport = currentStateRef.current.reviewReport;
            if (currentReviewReport) {
              updatedRulesData = _toConsumableArray(currentReviewReport);
              ruleIndex = updatedRulesData.findIndex(function (r) {
                return r.rule.uuid === ruleId;
              });
              if (ruleIndex !== -1) {
                updatedRulesData[ruleIndex] = _objectSpread(_objectSpread({}, updatedRulesData[ruleIndex]), {}, {
                  rule: _objectSpread(_objectSpread({}, updatedRulesData[ruleIndex].rule), {}, {
                    rule_responded: false
                  })
                });
                dispatch({
                  type: "SET_RULES_DATA",
                  payload: updatedRulesData
                });
              }
            }
          case 2:
            return _context14.a(2);
        }
      }, _callee14);
    }));
    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }(), [updateRespondedRules]);
  var setRuleSectionOrder = (0, _react.useCallback)(function (order, key) {
    return dispatch({
      type: "SET_RULE_SECTION_ORDER",
      payload: {
        order: order,
        key: key
      }
    });
  }, [dispatch]);
  var stopPolling = (0, _react.useCallback)(function () {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
      currentPollingReviewIdRef.current = null;
    }
  }, []);
  var startPolling = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(reviewId, isReportDone) {
      var pollingTickInFlight, pollInterval, _t6;
      return _regenerator().w(function (_context16) {
        while (1) switch (_context16.p = _context16.n) {
          case 0:
            stopPolling();
            currentPollingReviewIdRef.current = reviewId;
            if (!isReportDone) {
              _context16.n = 5;
              break;
            }
            _context16.p = 1;
            _context16.n = 2;
            return fetchReportData();
          case 2:
            _context16.n = 4;
            break;
          case 3:
            _context16.p = 3;
            _t6 = _context16.v;
            console.error("Error polling completed review ".concat(reviewId, ":"), _t6);
          case 4:
            return _context16.a(2);
          case 5:
            pollingTickInFlight = false;
            pollInterval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
              var isStillCurrentReview, currentAuthHeader, data, _data$errorMessage, details, currentSummaries, status, _t4, _t5;
              return _regenerator().w(function (_context15) {
                while (1) switch (_context15.p = _context15.n) {
                  case 0:
                    if (!pollingTickInFlight) {
                      _context15.n = 1;
                      break;
                    }
                    return _context15.a(2);
                  case 1:
                    pollingTickInFlight = true;
                    isStillCurrentReview = function isStillCurrentReview() {
                      return currentPollingReviewIdRef.current === reviewId;
                    };
                    _context15.p = 2;
                    if (isStillCurrentReview()) {
                      _context15.n = 3;
                      break;
                    }
                    clearInterval(pollInterval);
                    return _context15.a(2);
                  case 3:
                    currentAuthHeader = authHeaderRef.current;
                    if (currentAuthHeader) {
                      _context15.n = 4;
                      break;
                    }
                    return _context15.a(2);
                  case 4:
                    _context15.n = 5;
                    return (0, _api.fetchReport)(currentAuthHeader, reviewId);
                  case 5:
                    data = _context15.v;
                    if (isStillCurrentReview()) {
                      _context15.n = 6;
                      break;
                    }
                    return _context15.a(2);
                  case 6:
                    if (!(data.status === "ERROR")) {
                      _context15.n = 7;
                      break;
                    }
                    stopPolling();
                    dispatch({
                      type: "SET_IS_REPORT_DONE",
                      payload: false
                    });
                    dispatch({
                      type: "SET_LOADING",
                      payload: false
                    });
                    (0, _toast.toastDismissibleError)((_data$errorMessage = data.errorMessage) !== null && _data$errorMessage !== void 0 ? _data$errorMessage : "An unexpected error occurred.");
                    return _context15.a(2);
                  case 7:
                    dispatch({
                      type: "SET_IS_REPORT_DONE",
                      payload: data.status === "DONE"
                    });
                    if (!data.reportFileUrl) {
                      _context15.n = 12;
                      break;
                    }
                    _context15.p = 8;
                    _context15.n = 9;
                    return loadReviewDetails(reviewId, undefined, data);
                  case 9:
                    details = _context15.v;
                    if (isStillCurrentReview()) {
                      _context15.n = 10;
                      break;
                    }
                    return _context15.a(2);
                  case 10:
                    dispatch({
                      type: "SET_RULES_DATA",
                      payload: details.reviewReport
                    });
                    dispatch({
                      type: "SET_PLAYBOOKS",
                      payload: details.playbooks
                    });
                    dispatch({
                      type: "SET_REVIEW_DOCX_BLOB_URL",
                      payload: details.reviewDocxBlobUrl
                    });
                    dispatch({
                      type: "SET_CONCEDED_RULES",
                      payload: details.concededRules || []
                    });
                    dispatch({
                      type: "SET_RESPONDED_RULES",
                      payload: details.respondedRules || []
                    });
                    dispatch({
                      type: "SET_VALIDATION_MESSAGE",
                      payload: details.validationMessage
                    });
                    dispatch({
                      type: "SET_BOOKMARK_PARA_INDEX",
                      payload: details.bookmarkToParaIndex
                    });
                    dispatch({
                      type: "SET_LOADING",
                      payload: false
                    });
                    currentSummaries = currentStateRef.current.reviewSummaries;
                    dispatch({
                      type: "SET_REVIEW_SUMMARIES",
                      payload: currentSummaries.map(function (s) {
                        return s.id === reviewId ? _objectSpread(_objectSpread({}, s), {}, {
                          reviewReport: details.reviewReport,
                          reviewDocxBlobUrl: details.reviewDocxBlobUrl,
                          concededRules: details.concededRules,
                          respondedRules: details.respondedRules,
                          isReportDone: details.isReportDone
                        }) : s;
                      })
                    });
                    _context15.n = 12;
                    break;
                  case 11:
                    _context15.p = 11;
                    _t4 = _context15.v;
                    console.error("Failed to load review details during polling:", _t4);
                  case 12:
                    if (data.status === "DONE") {
                      stopPolling();
                    }
                    _context15.n = 14;
                    break;
                  case 13:
                    _context15.p = 13;
                    _t5 = _context15.v;
                    console.error("Error polling review:", _t5);
                    sendError(_t5, {
                      component: "ReviewedDocumentContext",
                      action: "poll_review_status",
                      reviewId: reviewId
                    });

                    // Stop polling on authentication errors — the token has expired
                    // and retrying will just generate noise in Sentry
                    status = _t5.status;
                    if (status === 401 || status === 403) {
                      stopPolling();
                      if (status === 401) {
                        console.warn("[dioptra-auth] review polling: 401 → notifySessionInvalid()");
                        (0, _authEvents.notifySessionInvalid)();
                      }
                    }
                  case 14:
                    _context15.p = 14;
                    pollingTickInFlight = false;
                    return _context15.f(14);
                  case 15:
                    return _context15.a(2);
                }
              }, _callee15, null, [[8, 11], [2, 13, 14, 15]]);
            })), 2000);
            pollingIntervalRef.current = pollInterval;
          case 6:
            return _context16.a(2);
        }
      }, _callee16, null, [[1, 3]]);
    }));
    return function (_x0, _x1) {
      return _ref0.apply(this, arguments);
    };
  }(), [sendError, stopPolling]);
  var loadReviewDetails = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(reviewId, summary, prefetchedData) {
      var _summary$review, _summary$playbooks;
      var review, data, currentAuthHeader, _yield$fetchReportPay, reportPayload, bookmarkToParaIndex, reviewReport, actionAppliedCacheKey, cachedActionApplied, recoveryWarningCacheKey, cachedRecoveryWarnings, playbooks, _review$userPlaybookI, playbookIds, _t7, _t8, _t9;
      return _regenerator().w(function (_context17) {
        while (1) switch (_context17.p = _context17.n) {
          case 0:
            if (!((_summary$review = summary === null || summary === void 0 ? void 0 : summary.review) !== null && _summary$review !== void 0)) {
              _context17.n = 1;
              break;
            }
            _t7 = _summary$review;
            _context17.n = 3;
            break;
          case 1:
            _context17.n = 2;
            return dioptraFetch("".concat((0, _envManager.getEnv)("WEBAPP_API_BASE_URL"), "/api/reviews/").concat(reviewId));
          case 2:
            _t7 = _context17.v;
          case 3:
            review = _t7;
            if (review) {
              _context17.n = 4;
              break;
            }
            throw new Error("Review not found");
          case 4:
            data = prefetchedData;
            if (data) {
              _context17.n = 7;
              break;
            }
            currentAuthHeader = authHeaderRef.current;
            if (currentAuthHeader) {
              _context17.n = 5;
              break;
            }
            throw new Error("Not authenticated");
          case 5:
            _context17.n = 6;
            return (0, _api.fetchReport)(currentAuthHeader, reviewId);
          case 6:
            data = _context17.v;
          case 7:
            _context17.n = 8;
            return fetchReportPayload(data);
          case 8:
            _yield$fetchReportPay = _context17.v;
            reportPayload = _yield$fetchReportPay.reportPayload;
            bookmarkToParaIndex = _yield$fetchReportPay.bookmarkMap;
            reviewReport = (0, _rules.parseReport)(reportPayload);
            reviewReport.forEach(function (rule) {
              var _review$respondedRule, _review$concededRules;
              var isResponded = ((_review$respondedRule = review.respondedRules) === null || _review$respondedRule === void 0 ? void 0 : _review$respondedRule.includes(rule.rule.uuid)) || false;
              var isConceded = ((_review$concededRules = review.concededRules) === null || _review$concededRules === void 0 ? void 0 : _review$concededRules.includes(rule.rule.uuid)) || false;
              rule.rule.rule_responded = isResponded;
              rule.rule.rule_conceded = isConceded;
            });
            actionAppliedCacheKey = "action_applied_".concat(reviewId);
            _context17.p = 9;
            _context17.n = 10;
            return _cacheManager.cacheManager.getItem(actionAppliedCacheKey);
          case 10:
            cachedActionApplied = _context17.v;
            if (cachedActionApplied) {
              reviewReport.forEach(function (rule) {
                if (rule.action_plan) {
                  rule.action_plan.forEach(function (action, actionIndex) {
                    if (action.steps) {
                      action.steps.forEach(function (step, stepIndex) {
                        var actionKey = "".concat(rule.rule.uuid, "_").concat(actionIndex, "_").concat(stepIndex);
                        if (cachedActionApplied[actionKey] !== undefined) {
                          step.action_applied = cachedActionApplied[actionKey];
                        }
                      });
                    }
                  });
                }
              });
            }
            _context17.n = 12;
            break;
          case 11:
            _context17.p = 11;
            _t8 = _context17.v;
            console.error("Failed to load cached action_applied values:", _t8);
          case 12:
            // Mirror the action_applied load path for agent-recovery drift
            // warnings written by `updateActionRecoveryWarning` (see reducer
            // case `UPDATE_ACTION_RECOVERY_WARNING`).
            recoveryWarningCacheKey = "recovery_warning_".concat(reviewId);
            _context17.p = 13;
            _context17.n = 14;
            return _cacheManager.cacheManager.getItem(recoveryWarningCacheKey);
          case 14:
            cachedRecoveryWarnings = _context17.v;
            if (cachedRecoveryWarnings) {
              reviewReport.forEach(function (rule) {
                if (rule.action_plan) {
                  rule.action_plan.forEach(function (action, actionIndex) {
                    if (action.steps) {
                      action.steps.forEach(function (step, stepIndex) {
                        var actionKey = "".concat(rule.rule.uuid, "_").concat(actionIndex, "_").concat(stepIndex);
                        if (cachedRecoveryWarnings[actionKey] !== undefined) {
                          step.recovery_warning = cachedRecoveryWarnings[actionKey];
                        }
                      });
                    }
                  });
                }
              });
            }
            _context17.n = 16;
            break;
          case 15:
            _context17.p = 15;
            _t9 = _context17.v;
            console.error("Failed to load cached recovery_warning values:", _t9);
          case 16:
            playbooks = (_summary$playbooks = summary === null || summary === void 0 ? void 0 : summary.playbooks) !== null && _summary$playbooks !== void 0 ? _summary$playbooks : [];
            if (!(playbooks.length > 0)) {
              _context17.n = 17;
              break;
            }
            cachePlaybooks(playbooks);
            _context17.n = 19;
            break;
          case 17:
            playbookIds = (_review$userPlaybookI = review.userPlaybookIDs) !== null && _review$userPlaybookI !== void 0 ? _review$userPlaybookI : review.userPlaybookID ? [review.userPlaybookID] : [];
            _context17.n = 18;
            return resolvePlaybooks(playbookIds);
          case 18:
            playbooks = _context17.v;
          case 19:
            return _context17.a(2, {
              review: review,
              reviewReport: reviewReport,
              playbooks: playbooks,
              reviewDocxBlobUrl: data.reviewFileUrl || null,
              concededRules: review.concededRules || [],
              respondedRules: review.respondedRules || [],
              isReportDone: (0, _api.isReviewComplete)(data.status),
              validationMessage: data.validationMessage || null,
              bookmarkToParaIndex: bookmarkToParaIndex
            });
        }
      }, _callee17, null, [[13, 15], [9, 11]]);
    }));
    return function (_x10, _x11, _x12) {
      return _ref10.apply(this, arguments);
    };
  }(), [cachePlaybooks, resolvePlaybooks]);
  var applyActiveReview = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(reviewId) {
      var summary, details, _t0, _t1;
      return _regenerator().w(function (_context18) {
        while (1) switch (_context18.p = _context18.n) {
          case 0:
            // Selecting a different review: stop polling immediately, before the async loads.
            stopPolling();
            if (reviewId) {
              _context18.n = 1;
              break;
            }
            dispatch({
              type: "SET_CURRENT_REVIEW_ID",
              payload: null
            });
            dispatch({
              type: "SET_RULES_DATA",
              payload: null
            });
            dispatch({
              type: "SET_PLAYBOOKS",
              payload: null
            });
            dispatch({
              type: "SET_REVIEW_DOCX_BLOB_URL",
              payload: null
            });
            dispatch({
              type: "SET_CONCEDED_RULES",
              payload: []
            });
            dispatch({
              type: "SET_RESPONDED_RULES",
              payload: []
            });
            dispatch({
              type: "SET_IS_REPORT_DONE",
              payload: false
            });
            dispatch({
              type: "SET_VALIDATION_MESSAGE",
              payload: null
            });
            dispatch({
              type: "SET_RULE_SECTION_ORDER",
              payload: {
                order: null,
                key: null
              }
            });
            dispatch({
              type: "SET_BOOKMARK_PARA_INDEX",
              payload: null
            });
            dispatch({
              type: "SET_LOADING",
              payload: false
            });
            return _context18.a(2);
          case 1:
            dispatch({
              type: "SET_LOADING",
              payload: true
            });
            dispatch({
              type: "SET_CURRENT_REVIEW_ID",
              payload: reviewId
            });
            dispatch({
              type: "SET_RULE_SECTION_ORDER",
              payload: {
                order: null,
                key: null
              }
            });
            dispatch({
              type: "SET_BOOKMARK_PARA_INDEX",
              payload: null
            });
            summary = currentStateRef.current.reviewSummaries.find(function (s) {
              return s.id === reviewId;
            }); // If review doesn't exist in current summaries, refresh from Word comments
            if (summary) {
              _context18.n = 5;
              break;
            }
            _context18.p = 2;
            _context18.n = 3;
            return fetchReportData();
          case 3:
            summary = currentStateRef.current.reviewSummaries.find(function (s) {
              return s.id === reviewId;
            });
            _context18.n = 5;
            break;
          case 4:
            _context18.p = 4;
            _t0 = _context18.v;
            console.error("Failed to refresh from Word comments:", _t0);
          case 5:
            _context18.p = 5;
            _context18.n = 6;
            return loadReviewDetails(reviewId, summary);
          case 6:
            details = _context18.v;
            dispatch({
              type: "SET_RULES_DATA",
              payload: details.reviewReport
            });
            dispatch({
              type: "SET_PLAYBOOKS",
              payload: details.playbooks
            });
            dispatch({
              type: "SET_REVIEW_DOCX_BLOB_URL",
              payload: details.reviewDocxBlobUrl
            });
            dispatch({
              type: "SET_CONCEDED_RULES",
              payload: details.concededRules || []
            });
            dispatch({
              type: "SET_RESPONDED_RULES",
              payload: details.respondedRules || []
            });
            dispatch({
              type: "SET_IS_REPORT_DONE",
              payload: details.isReportDone
            });
            dispatch({
              type: "SET_VALIDATION_MESSAGE",
              payload: details.validationMessage
            });
            dispatch({
              type: "SET_BOOKMARK_PARA_INDEX",
              payload: details.bookmarkToParaIndex
            });
            if (details.isReportDone) {
              _context18.n = 7;
              break;
            }
            _context18.n = 7;
            return startPolling(reviewId, false);
          case 7:
            _context18.n = 11;
            break;
          case 8:
            _context18.p = 8;
            _t1 = _context18.v;
            console.error("Failed to load review ".concat(reviewId, ":"), _t1);
            sendError(_t1, {
              component: "ReviewedDocumentContext",
              action: "load_review_details",
              reviewId: reviewId
            });

            // For new reviews that fail to load initially, still start polling
            if (summary) {
              _context18.n = 10;
              break;
            }
            dispatch({
              type: "SET_RULES_DATA",
              payload: null
            });
            dispatch({
              type: "SET_CONCEDED_RULES",
              payload: []
            });
            dispatch({
              type: "SET_RESPONDED_RULES",
              payload: []
            });
            _context18.n = 9;
            return startPolling(reviewId, false);
          case 9:
            _context18.n = 11;
            break;
          case 10:
            dispatch({
              type: "SET_CURRENT_REVIEW_ID",
              payload: null
            });
            dispatch({
              type: "SET_RULES_DATA",
              payload: null
            });
            dispatch({
              type: "SET_PLAYBOOKS",
              payload: null
            });
            dispatch({
              type: "SET_REVIEW_DOCX_BLOB_URL",
              payload: null
            });
            dispatch({
              type: "SET_CONCEDED_RULES",
              payload: []
            });
            dispatch({
              type: "SET_RESPONDED_RULES",
              payload: []
            });
            dispatch({
              type: "SET_IS_REPORT_DONE",
              payload: false
            });
            dispatch({
              type: "SET_VALIDATION_MESSAGE",
              payload: null
            });
          case 11:
            _context18.p = 11;
            dispatch({
              type: "SET_LOADING",
              payload: false
            });
            return _context18.f(11);
          case 12:
            return _context18.a(2);
        }
      }, _callee18, null, [[5, 8, 11, 12], [2, 4]]);
    }));
    return function (_x13) {
      return _ref11.apply(this, arguments);
    };
  }(), [loadReviewDetails, sendError, startPolling, stopPolling]);
  var fetchReportData = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
    var loadReviewSummary, reviewIds, testReviewIds, uuidRegex, uniqueIds, summaries, filteredSummaries, _t12;
    return _regenerator().w(function (_context20) {
      while (1) switch (_context20.p = _context20.n) {
        case 0:
          loadReviewSummary = /*#__PURE__*/function () {
            var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(reviewId) {
              var _review$userPlaybookI2, review, playbookIds, playbooks, reviewReport, isReportDone, currentAuthHeader, data, _yield$fetchReportPay2, reportPayload, bookmarkMap, status, _t10, _t11;
              return _regenerator().w(function (_context19) {
                while (1) switch (_context19.p = _context19.n) {
                  case 0:
                    _context19.p = 0;
                    _context19.n = 1;
                    return dioptraFetch("".concat((0, _envManager.getEnv)("WEBAPP_API_BASE_URL"), "/api/reviews/").concat(reviewId));
                  case 1:
                    review = _context19.v;
                    playbookIds = (_review$userPlaybookI2 = review.userPlaybookIDs) !== null && _review$userPlaybookI2 !== void 0 ? _review$userPlaybookI2 : review.userPlaybookID ? [review.userPlaybookID] : [];
                    _context19.n = 2;
                    return resolvePlaybooks(playbookIds);
                  case 2:
                    playbooks = _context19.v;
                    reviewReport = [];
                    isReportDone = review.status === "DONE";
                    if (!isReportDone) {
                      _context19.n = 8;
                      break;
                    }
                    _context19.p = 3;
                    currentAuthHeader = authHeaderRef.current;
                    if (currentAuthHeader) {
                      _context19.n = 4;
                      break;
                    }
                    return _context19.a(2, null);
                  case 4:
                    _context19.n = 5;
                    return (0, _api.fetchReport)(currentAuthHeader, reviewId);
                  case 5:
                    data = _context19.v;
                    _context19.n = 6;
                    return fetchReportPayload(data);
                  case 6:
                    _yield$fetchReportPay2 = _context19.v;
                    reportPayload = _yield$fetchReportPay2.reportPayload;
                    bookmarkMap = _yield$fetchReportPay2.bookmarkMap;
                    if (reviewId === currentStateRef.current.currentReviewId) {
                      dispatch({
                        type: "SET_BOOKMARK_PARA_INDEX",
                        payload: bookmarkMap
                      });
                    }
                    reviewReport = (0, _rules.parseReport)(reportPayload);
                    reviewReport.forEach(function (rule) {
                      var _review$respondedRule2, _review$concededRules2;
                      var isResponded = ((_review$respondedRule2 = review.respondedRules) === null || _review$respondedRule2 === void 0 ? void 0 : _review$respondedRule2.includes(rule.rule.uuid)) || false;
                      var isConceded = ((_review$concededRules2 = review.concededRules) === null || _review$concededRules2 === void 0 ? void 0 : _review$concededRules2.includes(rule.rule.uuid)) || false;
                      rule.rule.rule_responded = isResponded;
                      rule.rule.rule_conceded = isConceded;
                    });
                    _context19.n = 8;
                    break;
                  case 7:
                    _context19.p = 7;
                    _t10 = _context19.v;
                    console.error("Error loading report for review ".concat(reviewId, ":"), _t10);
                    sendError(_t10, {
                      component: "ReviewedDocumentContext",
                      action: "fetch_report_payload",
                      reviewId: reviewId
                    });
                  case 8:
                    return _context19.a(2, {
                      id: reviewId,
                      review: review,
                      playbooks: playbooks,
                      reviewReport: reviewReport,
                      author: review.author || null,
                      createdAt: review.createdAt || null,
                      isReportDone: isReportDone,
                      concededRules: review.concededRules || null,
                      respondedRules: review.respondedRules || null
                    });
                  case 9:
                    _context19.p = 9;
                    _t11 = _context19.v;
                    status = _t11 === null || _t11 === void 0 ? void 0 : _t11.status; // 404 is expected: review may belong to someone else in the same org
                    if (!(status === 404)) {
                      _context19.n = 10;
                      break;
                    }
                    return _context19.a(2, null);
                  case 10:
                    console.error("Error loading review summary ".concat(reviewId, ":"), _t11);
                    sendError(_t11, {
                      component: "ReviewedDocumentContext",
                      action: "load_review_summary",
                      reviewId: reviewId
                    });
                    return _context19.a(2, null);
                }
              }, _callee19, null, [[3, 7], [0, 9]]);
            }));
            return function loadReviewSummary(_x14) {
              return _ref13.apply(this, arguments);
            };
          }();
          dispatch({
            type: "SET_LOADING",
            payload: true
          });
          _context20.p = 1;
          _context20.n = 2;
          return (0, _document.fetchMultiplePropertyValuesFromDocComments)(_constants.DIOPTRA_REVIEW_ID);
        case 2:
          reviewIds = _context20.v;
          _context20.n = 3;
          return (0, _document.fetchMultiplePropertyValuesFromDocComments)(_constants.DIOPTRA_TEST_REVIEW_ID);
        case 3:
          testReviewIds = _context20.v;
          uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
          uniqueIds = Array.from(new Set([].concat(_toConsumableArray(reviewIds), _toConsumableArray(testReviewIds)).filter(function (id) {
            return uuidRegex.test(id);
          })));
          if (!(uniqueIds.length === 0)) {
            _context20.n = 4;
            break;
          }
          dispatch({
            type: "SET_REVIEW_SUMMARIES",
            payload: []
          });
          return _context20.a(2, []);
        case 4:
          _context20.n = 5;
          return Promise.all(uniqueIds.map(loadReviewSummary));
        case 5:
          summaries = _context20.v;
          filteredSummaries = summaries.filter(function (summary) {
            return Boolean(summary);
          });
          dispatch({
            type: "SET_REVIEW_SUMMARIES",
            payload: filteredSummaries
          });
          return _context20.a(2, filteredSummaries);
        case 6:
          _context20.p = 6;
          _t12 = _context20.v;
          console.error("Data loading or parsing failed:", _t12);
          sendError(_t12, {
            component: "ReviewedDocumentContext",
            action: "fetch_report_data"
          });
          (0, _toast.toastError)("Failed to load report data");
          dispatch({
            type: "SET_REVIEW_SUMMARIES",
            payload: []
          });
          return _context20.a(2, []);
      }
    }, _callee20, null, [[1, 6]]);
  })), [dioptraFetch, resolvePlaybooks, sendError]);
  (0, _react.useEffect)(function () {
    // Capture initial fetch function to avoid dependency changes
    var initialFetch = /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
        var summaries, latestSummary, _t13;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.p = _context21.n) {
            case 0:
              _context21.p = 0;
              _context21.n = 1;
              return fetchReportData();
            case 1:
              summaries = _context21.v;
              if (!(summaries.length > 0 && !currentStateRef.current.currentReviewId)) {
                _context21.n = 2;
                break;
              }
              latestSummary = summaries.sort(function (a, b) {
                var dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
                var dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
                return dateB - dateA;
              })[0];
              _context21.n = 2;
              return applyActiveReview(latestSummary.id);
            case 2:
              _context21.n = 4;
              break;
            case 3:
              _context21.p = 3;
              _t13 = _context21.v;
              console.error("Initial fetchReportData failed:", _t13);
            case 4:
              return _context21.a(2);
          }
        }, _callee21, null, [[0, 3]]);
      }));
      return function initialFetch() {
        return _ref14.apply(this, arguments);
      };
    }();
    initialFetch();
    return function () {
      stopPolling();
    };
  }, []);

  // Process reviewReport for filtering and sorting — memoized so consumers get a stable
  // reference when the underlying data hasn't changed (prevents spurious effect re-runs).
  var stableReviewReport = (0, _react.useMemo)(function () {
    if (!state.reviewReport) return null;
    // Assign index from original playbook position BEFORE filtering so that
    // makeRuleDocumentOrderComparator's fallback always sees the original order.
    var data = state.reviewReport.map(function (rule, idx) {
      return _objectSpread(_objectSpread({}, rule), {}, {
        index: idx
      });
    }).filter(function (rule) {
      if (!state.searchFilter) {
        return true;
      }
      return (0, _foldedTextSearch.matchesSearch)(rule.rule.name, state.searchFilter);
    });
    if (data) {
      switch (state.selectedRulesOrder) {
        case RulesOrderType.Order:
          {
            data = data.sort(function (r1, r2) {
              return r1.index - r2.index;
            });
            break;
          }
        case RulesOrderType.Priority:
          {
            var priority = {
              "Hightrue": 0,
              "Mediumtrue": 1,
              "Lowtrue": 2,
              "Drafttrue": 3,
              "Highfalse": 4,
              "Mediumfalse": 5,
              "Lowfalse": 6,
              "Draftfalse": 7
            };
            data = data.sort(function (r1, r2) {
              return priority[r1.importance + r1.match] - priority[r2.importance + r2.match] || r1.index - r2.index;
            });
            break;
          }
        default:
          break;
      }
    }
    return data;
  }, [state.reviewReport, state.searchFilter, state.selectedRulesOrder]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ReviewedDocumentContext.Provider, {
    value: _objectSpread(_objectSpread({}, state), {}, {
      reviewReport: stableReviewReport,
      setSelectedRuleUuid: function setSelectedRuleUuid(uuid) {
        return dispatch({
          type: "SET_SELECTED_RULE_UUID",
          payload: uuid
        });
      },
      setPlaybooks: function setPlaybooks(playbooks) {
        return dispatch({
          type: "SET_PLAYBOOKS",
          payload: playbooks
        });
      },
      applyActiveReview: applyActiveReview,
      orderRules: function orderRules(order) {
        return dispatch({
          type: "SET_RULES_ORDER",
          payload: order
        });
      },
      getRuleBookmarkNames: getRuleBookmarkNames,
      getRuleTrackedChanges: getRuleTrackedChanges,
      updateActionApplied: function updateActionApplied(ruleUuid, actionIndex, stepIndex, applied) {
        return dispatch({
          type: "UPDATE_ACTION_APPLIED",
          payload: {
            ruleUuid: ruleUuid,
            actionIndex: actionIndex,
            stepIndex: stepIndex,
            applied: applied
          }
        });
      },
      updateActionRecoveryWarning: function updateActionRecoveryWarning(ruleUuid, actionIndex, stepIndex, warning) {
        return dispatch({
          type: "UPDATE_ACTION_RECOVERY_WARNING",
          payload: {
            ruleUuid: ruleUuid,
            actionIndex: actionIndex,
            stepIndex: stepIndex,
            warning: warning
          }
        });
      },
      updateActionOoxml: function updateActionOoxml(ruleUuid, actionIndex, stepIndex, ooxmlBefore, ooxmlAfter) {
        return dispatch({
          type: "UPDATE_ACTION_OOXML",
          payload: {
            ruleUuid: ruleUuid,
            actionIndex: actionIndex,
            stepIndex: stepIndex,
            ooxmlBefore: ooxmlBefore,
            ooxmlAfter: ooxmlAfter
          }
        });
      },
      updateActionTexts: function updateActionTexts(ruleUuid, actionIndex, stepIndex, textRedline) {
        return dispatch({
          type: "UPDATE_ACTION_TEXTS",
          payload: {
            ruleUuid: ruleUuid,
            actionIndex: actionIndex,
            stepIndex: stepIndex,
            textRedline: textRedline
          }
        });
      },
      updateConcededRules: updateConcededRules,
      updateRespondedRules: updateRespondedRules,
      addConcededRule: addConcededRule,
      removeConcededRule: removeConcededRule,
      addRespondedRule: addRespondedRule,
      addRespondedRules: addRespondedRules,
      removeRespondedRule: removeRespondedRule,
      setRuleSectionOrder: setRuleSectionOrder,
      bookmarkToParaIndex: state.bookmarkToParaIndex
    }),
    "data-sentry-element": "ReviewedDocumentContext.Provider",
    "data-sentry-component": "ReviewedDocumentProvider",
    "data-sentry-source-file": "ReviewedDocumentContext.tsx",
    children: children
  });
};
var useReviewedDocument = exports.useReviewedDocument = function useReviewedDocument() {
  var context = (0, _react.useContext)(ReviewedDocumentContext);
  if (!context) {
    throw new Error("useReviewedDocument must be used within a ReviewedDocumentProvider");
  }
  return context;
};